// The partners' America/New_York day of a stored timestamp, for display. '' for null or an invalid value.
// It never throws: a value Date cannot convert (an object with no prototype, a Symbol, a BigInt, an object
// whose Symbol.toPrimitive throws) prints '' as well.
const FMT = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' });

export function easternDay(ts) {
  if (ts === null || ts === undefined || ts === '') return '';
  try {
    const d = new Date(ts);
    return Number.isNaN(d.getTime()) ? '' : FMT.format(d);
  } catch {
    return '';
  }
}
